<div class="container">
    <mat-toolbar>
        <span>Reasignaci&oacute;n masiva</span>
        <span class="sgd-spacer"></span>
        <div class="actions">
            <button mat-flat-button (click)="onReasignar()"
                matTooltip="Reasigna documentos a otro servidor p&uacute;blico "
                [disabled]="reasignarForm.invalid">                
                <mat-icon>supervisor_account</mat-icon> Reasignar
            </button>
        </div>
    </mat-toolbar>

    <p>Seleccione el usuario origen y destino para reasignar documento/s en elaboraci&oacute;n y recibidos.</p>

    <form [formGroup]="reasignarForm">
        <div class="row">
            <div class="col">
                <mat-form-field class="full-width">
                    <mat-label>Usuario origen</mat-label>
                    <input type="text" matInput formControlName="origen" [matAutocomplete]="autoOrigen">
                    <mat-autocomplete #autoOrigen="matAutocomplete" [displayWith]="displayFn">
                        @for (user of filteredOrigenUsers | async; track user) {
                        <mat-option [value]="user">
                            <div><span>{{user.apellidos +" "+ user.nombres }}</span> </div>
                            <small>{{(user.cargo||'')+" "+user.ciruc}} </small>
                            <span class="sgd-spacer"></span>
                            <mat-icon class="ultimo-uso-{{user.fechaUso|ultimoUso}}"
                                style="float: inline-end; margin-right: 0;">man</mat-icon>

                        </mat-option>
                        }
                    </mat-autocomplete>
                    @if (reasignarForm.controls.origen.hasError('required')) {
                    <mat-error>El usuario de origen es requerido</mat-error>
                    }
                    @if (reasignarForm.controls.origen.hasError('invalidUser')) {
                    <mat-error>Seleccione un usuario v&aacute;lido de la lista</mat-error>
                    }
                </mat-form-field>
            </div>

            <div class="col">
                <mat-form-field class="full-width">
                    <mat-label>Usuario destino</mat-label>
                    <input type="text" matInput formControlName="destinatario" [matAutocomplete]="autoDestino">
                    <mat-autocomplete #autoDestino="matAutocomplete" [displayWith]="displayFn">
                        @for (user of filteredDestinoUsers | async; track user) {
                        <mat-option [value]="user">
                            <div><span>{{user.apellidos +" "+ user.nombres}}</span> </div>
                            <small>{{(user.cargo||'')+" "+user.ciruc}} </small>
                            <span class="sgd-spacer"></span>
                            <mat-icon class="ultimo-uso-{{user.fechaUso|ultimoUso}}"
                                style="float: inline-end; margin-right: 0;">man</mat-icon>
                        </mat-option>
                        }
                    </mat-autocomplete>
                    @if (reasignarForm.controls.destinatario.hasError('required')) {
                    <mat-error>El usuario de destino es requerido</mat-error>
                    }
                    @if (reasignarForm.controls.destinatario.hasError('invalidUser')) {
                    <mat-error>Seleccione un usuario v&aacute;lido de la lista</mat-error>
                    }
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <mat-form-field class="full-width">
                    <mat-label>Comentario</mat-label>
                    <textarea matInput formControlName="comentario" rows="3"></textarea>
                    @if (reasignarForm.controls.comentario.hasError('required')) {
                    <mat-error>El comentario es requerido</mat-error>
                    }
                </mat-form-field>
            </div>
        </div>
    </form>


</div>